import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./ActivityPopUp.module.css";
import { Button } from "../components/Button/Button";

import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import logo from "./wwg_logo.png";
import ideaCenter from "./Idea_Center.png";
import help from "./Help.png";

import mobile from "mobileBridge";
import environment from "environment";

import { useActivityPopUp } from "./useActivityPopUp";
import { NavigationSvc } from "../navigationScv";
import { useTranslation } from "react-i18next";

/**
 * Opens a pop up to agree to T&C
 */

export function ActivityPopUp() {
  const {t} = useTranslation();
  const history = useHistory();
  const navigationSvc = new NavigationSvc();

  const { updateUserActivity } = useActivityPopUp();

  const handleGoBack = () => {
    history.goBack();
  };

  const onDismiss = async () => {
    try {
      await updateUserActivity.mutateAsync();
    } catch (error) {
      console.error(t("Failed to update user activity"), error);
    }
    handleGoBack();
  };

  return (
    <div className={styles.container}>
      <div className={styles.row}>
        <img src={logo} />
        <div className={styles.title}>{t("How are we doing")}</div>
      </div>
      <div className={styles.row}>
        <div className={styles.info}>
          {t("As an IBO in your first year")}
        </div>
      </div>
      <div className={styles.row}>
        <div className={styles.header}>{t("Ideas")}</div>
        <img
          className={styles.imageLink}
          src={ideaCenter}
          onClick={() => {
            mobile.isApp()
              ? navigationSvc.goToApp("idea-center", {})
              : window.open(environment.ideaCenterUrl, "_blank");
          }}
        />
        <div className={styles.info}>
          <i>
            {t("Search ideas other IBOs have")}
          </i>
        </div>
      </div>
      <div className={styles.row}>
        <div className={styles.header}>{t("Questions")}</div>
        <img
          className={styles.imageLink}
          src={help}
          onClick={() => {
            mobile.isApp()
              ? navigationSvc.goToApp("help", {})
              : window.open(environment.helpUrl, "_blank");
          }}
        />
        <div className={styles.info}>
          <i>{t("Questions")}</i>
        </div>
      </div>
      <div className={styles.divider} />
      <Button
        onClick={onDismiss}
        buttonText={t("Dismiss")}
        className={styles.btnColor}
      ></Button>
    </div>
  );
}

ActivityPopUp.propTypes = {};
